import { SettingsPartyContainer } from 'src/containers/SoftwareEscrow/Settings';
import { EscrowPartyTypeEnum } from 'src/graphql/schema';

const SettingsBeneficiary = () => {
  return <SettingsPartyContainer partyType={EscrowPartyTypeEnum.Beneficiary} />;
};

export default SettingsBeneficiary;
